// App.tsx
import { ThemeProvider, CssBaseline, Fab } from '@mui/material'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom'
import { HelmetProvider } from "react-helmet-async";


import LoginPage from './pages/LoginPage'
import ForgetPasswordPage from './pages/ForgetPassword'
import TermsPage from './pages/Terms'
import PrivacyPolicyPage from './pages/PrivacyPolicy'
import DashboardPage from './pages/Dashboard'
import DriversPage from './pages/Drivers'
import DeliverPage from './pages/Deliver'
import SchedulePage from './pages/Schedule'
import SchedulesPage from './pages/Schedules'
import LocalShippingPage from './pages/LocalShipping'
import KitchenPage from './pages/Kitchen'
import OrdersPage from './pages/Orders'
import OrdersDetailPage from './pages/OrdersDetail'
import ProductsPage from './pages/Products'
import CouponsPage from './pages/Coupons'
import theme from './theme/theme'
import PrivateRoute from './routes/PrivateRoute'
import SettingsPage from './pages/Settings'
import SigninRoute from './routes/SigninRoute'
import DeleteAccountPage from './pages/DeleteAccount'
import SupportPage from './pages/Support'

function AppContent() {
  const location = useLocation()

  return (
    <>
      <Routes>
        {/* <Route path="/" element={<LandingPage />} /> */}
        <Route path="/recuperar-contrasena" element={<ForgetPasswordPage />} />
        {/* <Route path="/lunchy-terminos-y-condiciones" element={<TermsPage />} /> */}
        {/* <Route path="/lunchy-politicas-de-privacidad" element={<PrivacyPolicyPage />} /> */}
        {/* <Route path="/lunchy-eliminacion-de-cuenta" element={<DeleteAccountPage />} /> */}
        {/* <Route path="/lunchy-soporte" element={<SupportPage />} /> */}
        
        {/* Privadas */}
        <Route path="/" element={<SigninRoute><LoginPage /></SigninRoute>} />
        <Route path="/ingreso" element={<SigninRoute><LoginPage /></SigninRoute>} />

        {/* Privadas */}
        <Route path="/dashboard" element={<PrivateRoute><KitchenPage /></PrivateRoute>} />
        {/* <Route path="/cocina" element={<PrivateRoute><KitchenPage /></PrivateRoute>} /> */}
        {/* <Route path="/asignacion" element={<PrivateRoute><DeliverPage /></PrivateRoute>} /> */}
        <Route path="/conductores" element={<PrivateRoute><DriversPage /></PrivateRoute>} />
        {/* <Route path="/productos" element={<PrivateRoute><ProductsPage /></PrivateRoute>} /> */}
        <Route path="/ordenes" element={<PrivateRoute><OrdersPage /></PrivateRoute>} />
        {/* <Route path="/pedidos/:id" element={<PrivateRoute><OrdersDetailPage /></PrivateRoute>} /> */}
        {/* <Route path="/cupones" element={<PrivateRoute><CouponsPage /></PrivateRoute>} /> */}
        {/* <Route path="/programacion" element={<PrivateRoute><SchedulePage /></PrivateRoute>} /> */}
        {/* <Route path="/programaciones" element={<PrivateRoute><SchedulesPage /></PrivateRoute>} /> */}
        {/* <Route path="/zonas-entrega" element={<PrivateRoute><LocalShippingPage /></PrivateRoute>} /> */}
        {/* <Route path="/ajustes" element={<PrivateRoute><SettingsPage /></PrivateRoute>} /> */}
      </Routes>

      
    </>
  )
}

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter>
          <AppContent />
        </BrowserRouter>
      </ThemeProvider>
    </HelmetProvider>
  )
}

export default App
